export const getLegend = state => state.ui.legend;
export const getDialog = state => state.ui.dialog;
export const getlayerFilters = state => state.ui.layerFilters;
export const getMobileMaxDetails = state => state.ui.mobileMaxDetails;
export const getMobileLinks = state => state.ui.mobileLinks;
export const getDetailTray = state => state.ui.detailTray;
export const getMobileLayers = state => state.ui.mobileLayers;
export const getDrawingOverlay = state => state.ui.drawingOverlay;
export const getUserLocationError = state => state.ui.userLocationError;
